<script lang="ts" setup>
import image from '~/assets/images/confirmation_dialog.webp';

const visible = defineModel<boolean>('visible');
const emit = defineEmits<{
  (event: 'skip'): void;
}>();

const { t } = useI18n();

const secondStepVisible = ref(false);

const toSecondStep = () => {
  visible.value = false;
  secondStepVisible.value = true;
};
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :header="t('first.title')"
    modal
    dismissable-mask
    :draggable="false"
    class="max-w-96"
  >
    <p class="m-0 text-lg">{{ t('first.content') }}</p>
    <template #footer>
      <Button @click="visible = false" :label="t('first.reject')" severity="secondary" outlined />
      <Button @click="toSecondStep" :label="t('first.apply')" outlined />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="secondStepVisible"
    :header="t('second.title')"
    modal
    dismissable-mask
    :draggable="false"
    class="max-w-96"
  >
    <p class="m-0 text-lg">
      {{ t('first.content.0') }}
      <br />
      <br />
      {{ t('first.content.1') }}
    </p>
    <NuxtImg :src="image" width="600" height="400" class="w-full h-auto block mt-6" />
    <template #footer>
      <Button @click="secondStepVisible = false" :label="t('second.reject')" severity="secondary" outlined />
      <Button @click="emit('skip')" :label="t('second.apply')" outlined />
    </template>
  </Dialog>
</template>

<i18n>
en:
  first:
    title: Task without media
    content: You and your partner will be more interested if the task contains an image. Are you sure you want to skip this
      step?
    reject: Back
    apply: Confirm
  second:
    title: Are you sure?
    content:
      - This makes us sad🥲
      - Tasks with images fill the site with an atmosphere of desire for sex💞 Are you still sure you want to leave this
        task without media?
    reject: Back
    apply: Skip

ru:
  first:
    title: Задание без медиа
    content: Вам и вашему партнеру будет интереснее, если задание будет содержать изображение. Уверены, что хотите
      пропустить этот этап?
    reject: Назад
    apply: Подтвердить
  second:
    title: Вы уверены?
    content:
      - Нам становится от этого грустно🥲
      - Задания с изображениями наполняют сайт атмосферой желания секса💞 Вы все еще уверены, что хотите оставить это
        задание без медиа?
    reject: Назад
    apply: Пропустить

de:
  first:
    title: Aufgabe ohne Medien
    content: Für Sie und Ihren Partner ist es interessanter, wenn die Aufgabe ein Bild enthält. Möchten Sie diesen Schritt
      wirklich überspringen?
    reject: Zurück
    apply: Bestätigen
  second:
    title: Bist du sicher?
    content:
      - Das macht uns traurig🥲
      - Aufgaben mit Bildern füllen die Seite mit einer Atmosphäre der Lust auf Sex 💞 Sind Sie immer noch sicher, dass
        Sie diese Aufgabe ohne Medien verlassen möchten?
    reject: Zurück
    apply: Überspringen

es:
  first:
    title: Tarea sin medios
    content: Será más interesante para ti y tu pareja si la tarea contiene una imagen. ¿Estás seguro de que quieres omitir
      este paso?
    reject: Atrás
    apply: Confirmar
  second:
    title: ¿Está seguro?
    content:
      - Esto nos pone tristes🥲
      - Las tareas con imágenes llenan el sitio de una atmósfera de deseo sexual💞 ¿Aún estás seguro de querer dejar
        esta tarea sin medios?
    reject: Atrás
    apply: Saltar

fr:
  first:
    title: Tâche sans média
    content: Ce sera plus intéressant pour vous et votre partenaire si la tâche contient une image. Êtes-vous sûr de vouloir
      ignorer cette étape ?
    reject: Dos
    apply: Confirmer
  second:
    title: Es-tu sûr?
    content:
      - Cela nous rend triste🥲
      - Les tâches avec images remplissent le site d'une atmosphère de désir sexuel💞 Êtes-vous toujours sûr de vouloir
        quitter cette tâche sans média ?
    reject: Dos
    apply: Sauter
</i18n>
